export default "__VITE_ASSET___0eng3Jj__"